import { getRPCURL, } from "@bracket/chainography";
import { mainnet, } from "@reown/appkit/networks";
import { createAppKit, } from "@reown/appkit/react";
import { WagmiAdapter, } from "@reown/appkit-adapter-wagmi";
import type { CreateConnectorFn, } from "wagmi";
import { type Config, fallback, http, } from "wagmi";
import { mock, } from "./AnonConnector";

// const projectId = "041af0b969c39f4de7db2aaaeb58b8f8";
const projectId = "b7e6384a8966cd62718f936b80ae8e01";

// "85751c0a-1ef0-45c2-8db7-203ecc708533=ae26bb0eae653f44037e462902c221c4557bfb52b3e3b6fed892f88345f752e6"
const { protocol, hostname, port, } = globalThis.location;


const connectors: CreateConnectorFn[] = []
connectors.push(mock({ accounts: ["0xD84b85333C201E14387d5dD3dcd29cD65B00e384"], }))

const metadata = {
	name: "Bracket.fi App",
	description: "Bracket.fi Application",
	url: `${protocol}//${hostname}${port.length > 0 ? `:${port}` : ""}`,
	icons: [
		"https://bracket.fi/favicon.ico",
	],
};


const networks = [
	mainnet,
	// arbitrum,
	// bitlayer,
	// bitlayerTestnet,
];

const wagmiAdapter = new WagmiAdapter({
	networks,
	projectId,
	ssr: false,
	connectors,
	transports: {
		[mainnet.id]: fallback([ http(getRPCURL(mainnet.id)), ]),
		// [bitlayer.id]: fallback([ http(getRPCURL(bitlayer.id)), ]),
		// [bitlayerTestnet.id]: fallback([ http(getRPCURL(bitlayerTestnet.id)), ]),
		// [arbitrum.id]: fallback([ http(getRPCURL(arbitrum.id)), ]),
	},
});

export const modal = createAppKit({
	adapters: [
		wagmiAdapter,
	],
	networks: [
		mainnet,
		// bitlayer,
		// bitlayerTestnet,
		// arbitrum,
	],
	projectId,
	metadata,
	excludeWalletIds: [
		"anonymous",
	],
	// https://walletguide.walletconnect.network/
	featuredWalletIds: [
		"38f5d18bd8522c244bdd70cb4a68e0e718865155811c043f052fb9f1c51de662", //bitget
		"c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96", //metamask
		"18388be9ac2d02726dbac9777c96efaac06d744b2f6d580fccdd4127a6d01fd1", // rabby
	],
	includeWalletIds: [
		"38f5d18bd8522c244bdd70cb4a68e0e718865155811c043f052fb9f1c51de662", //bitget
		"971e689d0a5be527bac79629b4ee9b925e82208e5168b733496a09c0faed0709", //okx
		"1ae92b26df02f0abca6304df07debccd18262fdf5fe82daa81593582dac9a369", //rainbow
		"8a0ee50d1f22f6651afcae7eb4253e52a3310b90af5daef78a8c4929a9bb99d4", //binance
		"aba1f652e61fd536e8a7a5cd5e0319c9047c435ef8f7e907717361ff33bb3588", //gate
		"163d2cf19babf05eb8962e9748f9ebe613ed52ebf9c8107c9a0f104bfcf161b3", // brave
		"fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa", //coinbase
	],
	features: {
		swaps: false,
		onramp: false,
		email: false,
		emailShowWallets: false,
		socials: false,
		history: false,
		analytics: true,
		allWallets: false,
		smartSessions: false,
	},
});

export const wagmiConfig = wagmiAdapter.wagmiConfig as Config;
